import angular from "angular";

import "ngstorage";
import auth from "../../services/auth.js";
import companies from "../../services/companies.js";
import security from "../../services/security.js";
import env from "../../services/env.js";

const EINREGEX = /^\d{2}\-?\d{7}$/;

class AccountprofileController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    CompaniesService,
    SignupValidator,
    SecurityService,
    $timeout,
    $rootScope,
    EnvService,
    ngProgressFactory,
    $scope,
    $location,
    ProfilesService
  ) {
    this.name = "accountprofile";
    $localStorage.activeStateName = "accountprofile";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.$auth = AuthService;
    this.validation = {};
    this.validator = SignupValidator;
    this.canValidate = false;
    this.$timeout(() => (this.canValidate = true), 1000);
    this.$companies = CompaniesService;
    this.$security = SecurityService;
    this.$progress = ngProgressFactory.createInstance();
    this.$rootScope = $rootScope;
    this.passNotMatching = false;
    this.$location = $location;
    this.editing_percentage = false;
    this.showRoleButton = false;
    this.activeTab = "profile";
    this.updatePasswordFormInvalid = true;
    this.$env = EnvService;
    this.stripe = window.Stripe(this.$env.EnvironmentConfig.stripeKey);
    this.showPaymentInfo = false;
    this.$profiles = ProfilesService;
    this.passwordData = {};
    this.newUserObj = {
      firstName: null,
      lastName: null,
      email: null,
      // email2: null,
      password: null,
      // password2: null,
      phoneMobile: null,
    };
    this.showPictureSaveButton = 1;
    this.currentUser = this.$auth.getUserData();
    this.localData = {showHomeInfo: false, showCompanyInfo: false};
    this.notiFormDisabled = true;
    this.bounds = {};
    this.phoneChange = undefined;
    this.phone_class = "";
    this.invitingUser = false;
    this.disableMandateButton = false;
    this.bounds.left = 0;
    this.bounds.right = 0;
    this.prev_plan = null;
    this.bounds.top = 0;
    this.$stateParams = $stateParams;
    this.bounds.bottom = 0;
    this.currentUser.company.dateCreatedConvert = this.$security.getClientDate(this.currentUser.company.dateCreated);
    //this.loadSettings();
    this.setActivePageOnLeft();
    //this.invalidEIN = false;
    this.paymentInfos = this.currentUser.company.undeletedPaymentInfos;
    this.remain_loading_count = 0;

    if (this.$security.isUndefinedOrNull(this.currentUser.company.undeletedPaymentInfos)) {
      this.currentUser.company.paymentInfos = [];
    }

    this.plans = [];
    this.planId = this.currentUser.company.defaultPlan.id;
    this.updatedPlan = false;
    this.updateStatus = 0;
    this.setNotificationData();

    if (this.$security.isUndefinedOrNull(this.currentUser.company) || this.$security.isUndefinedOrNull(this.currentUser.company.companyLogoUri)) {
      this.currentUser.companyProfilePictureUrl = "/app/vendor/images/user-more.png";
    } else {
      this.currentUser.companyProfilePictureUrl = this.currentUser.company.companyLogoUri;
    }

    var _this = this;

    _this.myImage = "";
    _this.myCroppedImage = "";

    this.cardsArray = [];
    this.banksArray = [];

    this.stateList = [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DC",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
    ];

    if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
      _this.navOptions = [
        {
          type: "profile",
          isActive: "profile-menu-active",
          value: "Profile",
        },
        {type: "logo", isActive: "", value: "Company logo"},
        {type: "plans", isActive: "", value: "Subscription Plans"},
        {type: "payments", isActive: "", value: "Payment Options"},
        {type: "notifications", isActive: "", value: "Notifications"},
      ];
      _this.currentUser.isAdmin = true;
    } else {
      _this.navOptions = [
        {
          type: "profile",
          isActive: "profile-menu-active",
          value: "Profile",
        },
        {type: "logo", isActive: "", value: "Company logo"},
        {type: "payments", isActive: "", value: "Payment Options"},
        {type: "notifications", isActive: "", value: "Notifications"},
      ];
      _this.currentUser.isAdmin = false;
    }

    //_this.checkForRDS();

    if (!this.currentUser.homeContactInfo) {
      this.currentUser.homeContactInfo = {
        phoneMobile: null,
        streetLine1: null,
        city: null,
        state: null,
        zipCode: null,
      };
    }

    this.notificationCenter = [
      {
        title: "Roster",
        activated: false,
        sub_fields: [{
          title: "Daily Roster Updates",
          description: "Receive emails with daily updates regarding rosters for upcoming jobs"
        },
        {
          title: "Job Filled Update",
          description: "Receive an email when all job openings have been filled"
        },
        {
          title: "Pre-Shift Roster",
          description: "Receive an email with a link to the roster before the job is scheduled to start"
        }]
      },
      {
        title: "Job Status",
        activated: false,
        sub_fields: [{
          title: "Application Updates",
          description: "Receive emails when job receives applicants"
        },
        {
          title: "Payment Updates",
          description: "Receive reminders to submit payments and updates when payments have been submitted"
        },
        {
          title: "Job closure Updates",
          description: "Receive emails when jobs have been completed"
        }]
      },
      {
        title: "Live Job Updates",
        activated: false,
        sub_fields: [{
          title: "Shift start / end notifications",
          description: "Receive emails when shifts are starting and ending"
        },
        {
          title: "Jobbler Schedule Updates",
          description: "Receive emails when jobblers update their availability for a job (calling out, running late, or a change in schedule)"
        }]
      },
      {
        title: "Billing",
        activated: false,
        sub_fields: [{
          title: "Billing Updates",
          description: "Receive billing statements and notifications"
        },
        {
          title: "Linked Accounts Updates",
          description: "Receive notifications when payment methods are added"
        },
        {
          title: "Post Due Notifications",
          description: "Receive notifications about payments that are past due"
        }]
      }
    ];

    this.userTableRows = [
      {
        prop: 1,
        name: "First Name",
        value: this.currentUser.firstName,
        status: 1,
        type: 1,
      },
      {
        prop: 2,
        name: "Last Name",
        value: this.currentUser.lastName,
        status: 1,
        type: 1,
      },
      {
        prop: 3,
        name: "Phone (personal)",
        value: this.currentUser.homeContactInfo.phoneMobile ? this.currentUser.homeContactInfo.phoneMobile : "---",
        status: 1,
        type: 1,
      },
      {
        prop: 4,
        name: "Street Address",
        value: this.currentUser.homeContactInfo.streetLine1 ? this.currentUser.homeContactInfo.streetLine1 : "---",
        status: 1,
        type: 1,
      },
      {
        prop: 5,
        name: "City",
        value: this.currentUser.homeContactInfo.city ? this.currentUser.homeContactInfo.city : "---",
        status: 1,
        type: 1,
      },
      {
        prop: 6,
        name: "State",
        value: this.currentUser.homeContactInfo.state ? this.currentUser.homeContactInfo.state : "---",
        status: 1,
        type: 1,
        is_state: true,
      },
      {
        prop: 7,
        name: "Zipcode",
        value: this.currentUser.homeContactInfo.zipCode ? this.currentUser.homeContactInfo.zipCode : "---",
        status: 1,
        type: 1,
      },
    ];

    this.companyDisplayData = {
      company_name: this.currentUser.company.name,
      ein: this.currentUser.company.ein,
      legal_company_name: this.currentUser.company.legalCompanyName,
      company_phone: this.currentUser.company.mainContactInfo.phoneMobile || "",
      company_street_address: this.currentUser.company.mainContactInfo.streetLine1 || "",
      company_city: this.currentUser.company.mainContactInfo.city || "",
      company_state: this.currentUser.company.mainContactInfo.state || "",
      company_zip_code: this.currentUser.company.mainContactInfo.zipCode || "",
      company_bio: this.currentUser.company.description || "",
      billing_contact: this.currentUser.company.billingContactInfo.email,
    };

    this.userDisplayData = {
      firstName: this.currentUser.firstName,
      lastName: this.currentUser.lastName,
      homeContactInfo_phoneMobile: this.currentUser.homeContactInfo.phoneMobile,
      homeContactInfo_streetLine1: this.currentUser.homeContactInfo.streetLine1,
      homeContactInfo_city: this.currentUser.homeContactInfo.city,
      homeContactInfo_state: this.currentUser.homeContactInfo.state,
      homeContactInfo_zipCode: this.currentUser.homeContactInfo.zipCode,
    };

    this.initialCompanyData = Object.assign({}, this.companyDisplayData);
    this.initialUserData = Object.assign({}, this.userDisplayData);

    this.companyTableRows = [
      {
        prop: 8,
        name: "Company Name",
        value: this.currentUser.company.name,
        status: 1,
      },
      {
        prop: 11,
        name: "Phone (company)",
        value: this.currentUser.company.mainContactInfo.phoneMobile ? this.currentUser.company.mainContactInfo.phoneMobile : "---",
        status: 1,
        type: 2,
      },
      {
        prop: 12,
        name: "Street Address",
        value: this.currentUser.company.mainContactInfo.streetLine1 ? this.currentUser.company.mainContactInfo.streetLine1 : "---",
        status: 1,
        type: 2,
      },
      {
        prop: 13,
        name: "City",
        value: this.currentUser.company.mainContactInfo.city ? this.currentUser.company.mainContactInfo.city : "---",
        status: 1,
        type: 2,
      },
      {
        prop: 14,
        name: "State",
        value: this.currentUser.company.mainContactInfo.state ? this.currentUser.company.mainContactInfo.state : "---",
        status: 1,
        type: 2,
        is_state: true,
      },
      {
        prop: 15,
        name: "Zipcode",
        value: this.currentUser.company.mainContactInfo.zipCode ? this.currentUser.company.mainContactInfo.zipCode : "---",
        status: 1,
        type: 2,
      },
    ];

    _this.UpdatedCreditCardListener = _this.$rootScope.$on("UpdatedCreditCard", function ($event, params) {
      _this.cardsArray = [];

      if (params.user) {
        _this.currentUser = params.user;
        _this.paymentInfos = _this.currentUser.company.paymentInfos;
      }

      _this.$timeout(function () {
        try {
          _this.currentUser.company.paymentInfos.forEach(function (paymentInfo) {
            if (!paymentInfo.bankName) {
              paymentInfo.cardExpirationDate =
                moment().month(parseInt(paymentInfo.cardExpirationMonth)).format("MM") + "/" + paymentInfo.cardExpirationYear;
            }
          });
        } finally {
          _this.organizePaymentInfo(true, null);
        }
      }, 100);
    });

    _this.UpdatedBankAccountsListener = _this.$rootScope.$on("UpdatedBankAccounts", function ($event, params) {
      _this.setLoader();
      _this.pullLatestPaymentInfo(params.bankToRemove);
    });

    _this.$scope.$on("$destroy", _this.UpdatedCreditCardListener);
    _this.$scope.$on("$destroy", _this.UpdatedBankAccountsListener);

    _this.lookForPaymentFlag();

    this.enableToolTips();
  }

  enableToolTips() {
    this.$timeout(() => {
      $(".account-tool-tip").tooltip({}).tooltip("fixTitle");
    }, 200);
  }

  lookForPaymentFlag() {}

  setValidation({field, valid, message}) {
    if (this.canValidate)
      this.$timeout(() => {
        this.validation[field] = {
          valid,
          style: {borderColor: valid ? "green" : "red"},
          message,
        };
      });
    this.validation;
  }

  loadAllJobblePlans() {
    var _this = this;

    _this.remain_loading_count++;

    var req = {
      method: "GET",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/plans?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: {},
    };

    _this.$http(req).then(
      function (res) {
        _this.remain_loading_count--;
        //console.log(res.data);
      },
      function (res) {
        //console.log(res.data);
        _this.remain_loading_count--;
      }
    );
  }

  openFileDialog() {
    var _this = this;
    _this.$timeout(function () {
      jQuery("#fileCompanyLogo").trigger("click");
    });
  }

  fileToUploadCompany(file, uploadUrlCompany) {
    var _this = this;

    var fd = new FormData();

    fd.append("file", file);

    _this.remain_loading_count++;

    _this.$http
      .post(uploadUrlCompany, fd, {
        transformRequest: angular.identity,
        headers: {
          "Content-Type": undefined,
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
      })
      .then(function (response) {
        console.log("response?");
        console.dir(response);
      });
  }

  saveUserProfile(row) {
    var _this = this;

    row.status = 1;

    _this.$timeout(function () {
      _this.timer(row);
    }, 300);

    _this.$companies.updateUser(row).then(
      function (response) {
        _this.$timeout(function () {
          _this.$auth.reloadCurrentUser();
        }, 100);
      },
      function (error) {
        alert("error saving user information");
      }
    );
  }

  validatePhone(p) {

    console.log("validatePhone");
    console.dir(p);

    let phoneError = false;

    if (p.length === 1 && p === "1") {
      p = "";
    }
    const phonePattern = /^(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/;

    phoneError = !(p && phonePattern.test(p));

  }

  saveCompanyProfileInformation() {
    this.savingCompany = true;
    this.setLoader();

    if (!this.currentUser.company.billingContactInfo.email) {
      alert("Please add a billing contact to your profile. This email will receive invoices from Jobble.");
      this.savingCompany = false;
      this.unSetLoader();
      return;
    }

    this.setLoader();
    let diffPayloadCompany = this.findDiff("company");
    let diffPayloadUser = this.findDiff("user");
    let payload = {};
    payload = this.mapPayLoadToUserObj(diffPayloadUser.new);
    payload.company = this.mapPayloadToCompanyObj(diffPayloadCompany.new);

    this.$companies
      .saveCompanyProfileInformationNew(payload)
      .then((response) => {
        console.log("Save Company Response:", response.data);
        this.savingCompany = false;
        this.unSetLoader();
        if (payload.company.billingContactInfo.email) {
          this.updateUsersBillingEmail();
        }
      })
      .catch((err) => {
        console.log("error with saving user info");
        console.dir(err);
        this.savingCompany = false;
        this.unSetLoader();
        this.handleSavingUserError(err);
      });
  }

  handleSavingUserError(response) {
    alert("There was an error saving your information: " + response.data.message);
  }

  mapPayloadToCompanyObj(data) {
    let company = {};

    console.log("mapPayloadToCompanyObj");
    console.dir(data);

    company.description = data.company_bio;
    company.name = data.company_name;
    company.legalCompanyName = data.legal_company_name;
    company.ein = data.ein;
    company.numberOfLocations = data.number_of_locations;
    company.mainContactInfo = {};
    company.billingContactInfo = {};
    company.billingContactInfo.email = data.billing_contact;
    company.mainContactInfo.phoneMobile = data.company_phone;
    company.mainContactInfo.streetLine1 = data.company_street_address;
    company.mainContactInfo.city = data.company_city;
    company.mainContactInfo.state = data.company_state;
    company.mainContactInfo.zipCode = data.company_zip_code;

    return company;
  }

  mapPayLoadToUserObj(malFormedObj) {
    let user = {};
    user.homeContactInfo = {};

    console.log("mapPayLoadToUserObj");
    console.dir(malFormedObj);

    if (malFormedObj.homeContactInfo_city) {
      user.homeContactInfo.city = malFormedObj.homeContactInfo_city;
    }
    if (malFormedObj.homeContactInfo_phoneMobile) {
      user.homeContactInfo.phoneMobile = malFormedObj.homeContactInfo_phoneMobile;
    }
    if (malFormedObj.homeContactInfo_state) {
      user.homeContactInfo.state = malFormedObj.homeContactInfo_state;
    }
    if (malFormedObj.homeContactInfo_streetLine1) {
      user.homeContactInfo.streetLine1 = malFormedObj.homeContactInfo_streetLine1;
    }
    if (malFormedObj.homeContactInfo_zipCode) {
      user.homeContactInfo.zipCode = malFormedObj.homeContactInfo_zipCode;
    }
    if (malFormedObj.firstName) {
      user.firstName = malFormedObj.firstName;
    }
    if (malFormedObj.lastName) {
      user.lastName = malFormedObj.lastName;
    }

    return user;
  }

  findDiff(type) {
    let diff;
    let old;
    let newObj;

    if (type === "company") {
      old = this.initialCompanyData;
      newObj = this.companyDisplayData;

      diff = {
        old: _.pickBy(old, (value, key) => {
          return !_.isEqual(value, newObj[key]);
        }),
        new: _.pickBy(newObj, (value, key) => {
          return !_.isEqual(old[key], value);
        }),
      };
    } else {
      old = this.initialUserData;
      newObj = this.userDisplayData;

      diff = {
        old: _.pickBy(old, (value, key) => {
          return !_.isEqual(value, newObj[key]);
        }),
        new: _.pickBy(newObj, (value, key) => {
          return !_.isEqual(old[key], value);
        }),
      };
    }

    return diff;
  }

  timer(row) {
    var _this = this;

    if (row.type === 1) {
      _this.save_home_success = true;
      _this.$timeout(function () {
        _this.save_home_success = false;
      }, 8000);
    } else {
      _this.save_company_success = true;
      _this.$timeout(function () {
        _this.save_company_success = false;
      }, 8000);
    }
  }

  setDeleteCreditCard($index) {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetCreditCard", {index: $index});
    });
  }

  setDeleteBankAccount($index) {
    var _this = this;

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetBankAccount", {index: $index, banks: _this.banksArray});
    });
  }

  setVerifyBankAccount($index) {
    var _this = this;

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetBankAccount", {index: $index, banks: _this.banksArray});
    });
  }

  updatePlan() {
    var _this = this;
    _this.updatedPlan = false;
    _this.planId = _this.planForModal.id;
    let plan_id = _this.planForModal.id;
    _this.remain_loading_count++;
    _this.$auth.changePlans(plan_id).then(
      function (response) {
        console.log("what is the new plan");
        console.dir(response);
        console.dir(Array.isArray(response.data));
        if (Array.isArray(response.data)) {
          if (response.data[0].status === "error") {
            _this.handlePlansError(response.data[0]);
            return;
          }
        }
        _this.updatedPlan = true;
        _this.$timeout(function () {
          jQuery("#modal-save-profile-confirm").modal();
        });
        _this.$timeout(function () {
          _this.$auth.reloadCurrentUser();
        }, 100);
        _this.$timeout(function () {
          _this.remain_loading_count--;
        }, 300);
        _this.$timeout(function () {
          _this.getLatestCompanyPackage();
        }, 300);
        _this.findPlan(plan_id);
      },
      function (response) {
        _this.remain_loading_count--;
        log.info("in the error");
      }
    );
  }

  closePlansModal() {
    var _this = this;
    _this.displaySubChangeModal(_this.prev_plan);
    _this.$timeout(function () {
      jQuery("#modal-save-plan-confirm-modal").modal("toggle");
    }, 300);
  }

  handlePlansError(error) {
    var _this = this;
    console.log("handle plans error");
    console.dir(error);
    if (error.message === "No such customer: null") {
      _this.plansError = "Before you can change your subscription plan, you must add payment information.";
    } else if (error.message.indexOf("No such plan:") > -1) {
      _this.plansError = "This plan no longer exists. Please contact support.";
    } else {
      _this.plansError = "There was an issue contact support.";
    }

    _this.$timeout(function () {
      _this.remain_loading_count--;
    }, 500);
  }

  findPlan(plan_id) {
    var _this = this;
    try {
      _this.plans.forEach(function (plan) {
        if (plan.id === plan_id) {
          plan.isActive = "active-plan";
          _this.previousPlan = plan;
        } else {
          plan.isActive = undefined;
        }
      });
    } catch (err) {
      console.log("error looking plans");
    } finally {
      console.log("in the finally");
      _this.$timeout(function () {
        $("#modal-save-plan-confirm-modal").modal("toggle");
      });

      _this.$timeout(function () {
        $("#modal-save-profile-confirm-modal").modal();
      }, 500);
    }
  }

  addPaymentInfo() {
    var _this = this;
    console.log("add payment info");
    _this.$timeout(function () {
      $("#modal-save-plan-confirm-modal").modal("toggle");
    });

    _this.$timeout(function () {
      _this.$state.go("accountprofile-payment-information", {
        companyId: _this.currentUser.company.id,
      });
    }, 300);
  }

  navigateProfilePage(type) {
    //console.log('what about here?');
    this.navOptions.forEach(function (option) {
      if (option.type === type) {
        option.isActive = "profile-menu-active";
      } else {
        option.isActive = "";
      }
    });

    if (type === "profile") {
      this.activeTab = "profile";
    }

    if (type === "logo") {
      this.activeTab = "logo";
    }

    if (type === "plans") {
      this.activeTab = "plans";
    }

    if (type === "payments") {
      //console.log('we have some payments');
      this.activeTab = "payments";
    }

    if (type === "notifications") {
      //console.log('we have some payments');
      this.activeTab = "notifications";
    }
  }

  addUserModal() {
    var _this = this;
    _this.newUserObj = {
      firstName: null,
      lastName: null,
      email: null,
      // email2: null,
      password: null,
      // password2: null,
      phoneMobile: null,
    };
    _this.$timeout(function () {
      jQuery("#modal-add-user-confirm-modal").modal();
    }, 100);
  }

  validateNewUser(user) {
    var _this = this;

    var keys = Object.keys(user);
    var values = keys.map(function (v) {
      return user[v];
    });
    var retObj = {};

    retObj.status = true;
    retObj.message = "";

    try {
      for (var x = 0; x < keys.length; x++) {
        var val = user[keys[x]];
        if (this.$security.isUndefinedOrNull(val)) {
          if (keys[x] === "firstName") {
            retObj.message = "Please provide a first name before continuing.";
          }
          if (keys[x] === "lastName") {
            retObj.message = "Please provide a last name before continuing.";
          }
          if (keys[x] === "email") {
            retObj.message = "Please provide a valid email address before continuing.";
          }
          // if (keys[x] === "email2") {
          //     retObj.message = "Please provide a valid matching email address before continuing.";
          // }
          if (keys[x] === "password") {
            retObj.message = "Please provide a password before continuing.";
          }
          // if (keys[x] === "password2") {
          //     retObj.message = "Please provide a valid matching password before continuing.";
          // }
          if (keys[x] === "phoneMobile") {
            retObj.message = "Please provide a valid phone number.";
          }
          retObj.status = false;
          return retObj;
        }
      }
    } finally {
      try {
        // if (user.email !== user.email2) {
        //                 //     retObj.status = false;
        //                 //     retObj.message = "Please provide a matching email address.";
        //                 // }
        //                 // if (user.password !== user.password2) {
        //                 //     retObj.status = false;
        //                 //     retObj.message = "Please provide a matching passwords.";
        //                 // }
        return retObj;
      } finally {
        return retObj;
      }
    }
  }

  managerChecked() {}

  displaySubChangeModal(plan) {
    var _this = this;

    if (plan.isChecked) {
      plan.isChecked = false;
      return;
    }

    if (_this.currentUser.company.paymentInfos.length === 0 && !_this.currentUser.isAdmin) {
      _this.plans.forEach(function (plan) {
        plan.isChecked = false;
      });

      _this.$timeout(function () {
        jQuery("#modal-add-card").modal();
      }, 100);

      return;
    }
    try {
      var planFiltered = _this.plans.filter(function (p) {
        return p.isChecked === true;
      });
    } finally {
      if (planFiltered.length > 0) {
        planFiltered[0].isChecked = false;
        _this.prev_plan = planFiltered[0];
      }

      plan.isChecked = true;

      _this.$timeout(function () {
        jQuery("#modal-save-plan-confirm-modal").modal();
        _this.planForModal = plan;
      }, 100);
    }
  }

  change() {
    this.showSaveButton = true;
  }

  parsePhone(phoneNum) {
    var phoneNumber = "1" + phoneNum;

    return phoneNumber.replace(/\D/g, "");
  }

  isPhone(val) {
    return /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(val);
  }

  updateProfilePicture() {
    var _this = this;
    var uploadUrl = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.currentUser.id + "/files?format=json&fileType=4&replace=true";
    var uploadUrlCompany =
      _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/files?format=json&fileType=9&replace=true";

    if (!_this.$security.isUndefinedOrNull(_this.currentUser.companyPicture)) {
      _this.fileToUploadCompany(_this.currentUser.companyPicture, uploadUrlCompany);
    }
  }

  picChange() {
    this.showPictureSaveButton = true;
  }

  populateCardImage(info) {
    var _this = this;

    if (info.cardBrand === "American Express") {
      info.image = "fa fa-cc-amex";
    }
    if (info.cardBrand === "Visa") {
      info.image = "fa fa-cc-visa";
    }
    if (info.cardBrand === "Discover") {
      info.image = "fa fa-cc-discover";
    }
    if (info.cardBrand === "MasterCard") {
      info.image = "fa fa-cc-mastercard";
    }

    return info.image;
  }

  organizePaymentInfo(justCards, bankToRemove) {
    var _this = this;

    console.log("organizePaymentInfo");
    console.dir(_this.paymentInfos);
    let banksArrayTemp = [];
    let cardsArrayTemp = [];

    if (_this.paymentInfos && _this.paymentInfos.length > 0) {
      try {
        _this.paymentInfos.forEach(function (paymentInfo) {
          if (paymentInfo.bankName) {
            if (!justCards) {
              if (!paymentInfo.validated) {
                console.log("we need to display warning");
                _this.thereIsAtleastOneBankWithoutValidation = true;
              }
              banksArrayTemp.push(paymentInfo);
            }
          } else {
            paymentInfo.image = _this.populateCardImage(paymentInfo);
            cardsArrayTemp.push(paymentInfo);
          }
        });
      } finally {
        cardsArrayTemp.forEach(function (paymentInfo) {
          paymentInfo.cardExpirationDate =
            moment().month(parseInt(paymentInfo.cardExpirationMonth)).format("MM") + "/" + paymentInfo.cardExpirationYear;
        });

        _this.cardsArray = cardsArrayTemp;
        _this.banksArray = banksArrayTemp;
      }
    }
  }

  getArrayLength() {
    if (!this.cardsArray && !this.banksArray) {
      return 0;
    }

    return this.cardsArray.length + this.banksArray.length || 0;
  }

  organizeBankAccounts() {
    var _this = this;

    if (_this.paymentInfos) {
      _this.paymentInfos.forEach(function (paymentInfo) {
        if (paymentInfo.bankName) {
          _this.banksArray.push(paymentInfo);
        }
      });
    }
  }

  handleFileSelect(evt) {
    var _this = this;
  }

  onUpdate(data) {
    console.log("onUpdate");
    console.dir(data);
    console.dir(this.outputImage);
  }

  uploadFilesNew(file, errors) {
    var _this = this;

    _this.setLoader();

    var fd = new FormData();

    fd.append("file", file);

    if (errors.length > 0) {
      console.log("errors");
      console.dir(errors);
      _this.unSetLoader();

      if (errors[0].$error === "maxHeight") {
        alert("The logo you are attempting to upload is too large. Please choose another.");
      } else {
        alert("There is an issue with that image. Please choose a different one.");
      }

      _this.$timeout(function () {
        _this.$progress.complete();
      });

      return;
    }

    if (file) {
      console.log("in the file block");
      console.dir(file);
      _this.$progress.start();
      var uploadUrlCompany = _this.$auth.getUploadUrl(_this.currentUser.company.id, file);
      console.log("uploadUrlCompany");
      console.dir(uploadUrlCompany);
      _this.$http
        .post(uploadUrlCompany, fd, {
          headers: {
            "Content-Type": undefined,
            Authorization: "Bearer " + _this.currentUser.access_token,
          },
        })
        .then(
          function (response) {
            var callback = response.data;
            _this.$timeout(function () {
              console.log("call back from file upload...");
              console.dir(response);
              _this.unSetLoader();
              _this.cropInput = callback.mainFile.url;
              _this.currentUser.company.companyLogoUri = callback.mainFile.url;
              _this.$rootScope.companyLogoUri = callback.mainFile.url;
              _this.$rootScope.imgFromProfilePage = callback.mainFile.url;
              _this.currentUser.companyProfilePictureUrl = callback.mainFile.url;
              _this.$progress.complete();
              _this.$auth.reloadCurrentUser();
              _this.determineImageDimensions(callback.mainFile.url);
              _this.$rootScope.$emit("SetProfilePicture", {
                picture: callback.mainFile.url,
              });
            }, 100);
          },
          function (error) {
            _this.$timeout(function () {
              jQuery("#application-global-modal .modal-header button.close").trigger("click");
              _this.$progress.complete();
            }, 100);
            _this.$timeout(function () {
              alert("There is an issue with that image. Please choose a different one.");
            }, 1000);
          }
        );
    }
  }

  userCancelsMandate() {
    console.log("userCancelsMandate");
  }

  determineImageDimensions(url) {
    let myImg = document.querySelector("#company-logo-account-profile");

    if (myImg) {
      let imageClassForDisplay = this.$profiles.dimensionsCalc(myImg.clientHeight, myImg.clientWidth);

      this.$timeout(() => {
        $("#company-logo-account-profile").addClass(imageClassForDisplay);
      });
    }
  }

  setNotificationData() {
    var _this = this;

    _this.smsNoti = _this.currentUser.smsChatNotificationOn;
    _this.emailNoti = _this.currentUser.emailChatNotificationOn;

    _this.notiObj = {
      smsYes: null,
      smsNo: null,
      emailYes: null,
      emailNo: null,
    };

    if (_this.smsNoti || _this.smsNoti === null) {
      _this.smsNoti = true;
      _this.notiObj.smsYes = true;
      _this.notiObj.smsNo = false;
    } else {
      _this.smsNoti = false;
      _this.notiObj.smsYes = false;
      _this.notiObj.smsNo = true;
    }

    if (_this.emailNoti || _this.emailNoti === null) {
      _this.emailNoti = true;
      _this.notiObj.emailYes = true;
      _this.notiObj.emailNo = false;
    } else {
      _this.emailNoti = false;
      _this.notiObj.emailYes = false;
      _this.notiObj.emailNo = true;
    }
  }

  changeNotiStatus(status) {
    var _this = this;

    switch (status) {
      case 1:
        _this.notiObj.smsYes = true;
        _this.notiObj.smsNo = false;
        _this.notiFormDisabled = false;
        break;
      case 2:
        _this.notiObj.smsYes = false;
        _this.notiObj.smsNo = true;
        _this.notiFormDisabled = false;
        break;
      case 3:
        _this.notiObj.emailYes = true;
        _this.notiObj.emailNo = false;
        _this.notiFormDisabled = false;
        break;
      case 4:
        _this.notiObj.emailYes = false;
        _this.notiObj.emailNo = true;
        _this.notiFormDisabled = false;
        break;
    }
  }

  submitNotifications() {
    var _this = this;

    if (_this.notiObj.smsYes) {
      _this.currentUser.smsChatNotificationOn = true;
    } else {
      _this.currentUser.smsChatNotificationOn = false;
    }

    if (_this.notiObj.emailYes) {
      _this.currentUser.emailChatNotificationOn = true;
    } else {
      _this.currentUser.emailChatNotificationOn = false;
    }

    var req = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.currentUser.id + "?conf=web&format=json&fields=id",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: {
        smsChatNotificationOn: _this.currentUser.smsChatNotificationOn,
        emailChatNotificationOn: _this.currentUser.emailChatNotificationOn,
      },
    };

    _this.remain_loading_count = 1;

    _this.$http(req).then(
      function (res) {
        _this.remain_loading_count = 0;
      },
      function (res) {
        _this.remain_loading_count = 0;
      }
    );
  }

  phoneChangeFunc() {
    var _this = this;

    if (_this.newUserObj.phoneMobile) {
      var isPhoneNumber = _this.isPhone(_this.newUserObj.phoneMobile);

      if (!isPhoneNumber) {
        _this.phone_class = "error-with-phone";
      } else {
        _this.phone_class = "";
      }
    }
  }

  isPhone(val) {
    return /^[1][(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(val);
  }

  toggleEditButtonOn(x) {
    var _this = this;

    if (x === 1)
      _this.$timeout(function () {
        jQuery(".profile-edits-container .form-for-profile-wrapper .hidden-edit-homeinfo").show("fast");
      });
  }

  toggleEdit(x) {
    var _this = this;
    if (x === 1) _this.localData.is_home_info_being_edited = true;
  }

  toggleEditButtonOff(x) {
    var _this = this;

    if (x === 1)
      _this.$timeout(function () {
        jQuery(".profile-edits-container .form-for-profile-wrapper .hidden-edit-homeinfo").hide("fast");
      });
  }

  cancelEdit(row) {
    var _this = this;

    row.status = 1;
  }

  loadUsers() {
    var _this = this;
    _this.setLoader();
    _this.$companies.loadUsers().then(
      function (response) {
        _this.formatUsersNumbersAndAuth(response.data);
        _this.unSetLoader();
      },
      function (error) {
        alert("error getting company users");
      }
    );
  }

  triggerPhoneVerificationModal(number) {
    this.setLoader();
    this.$timeout(() => {
      this.numberToVerify = number;
      $("#verify-company-user").modal();
    });
    this.$timeout(() => {
      this.$profiles
        .sendSMSCode()
        .then((response) => {
          this.unSetLoader();
        })
        .catch((err) => {
          this.unSetLoader();
        });
    }, 1000);
  }

  formatUsersNumbersAndAuth(users) {
    try {
      users.forEach((u) => {
        if (u.homeContactInfo.phoneMobile) {
          let firstNum = Array.from(u.homeContactInfo.phoneMobile)[0];

          if (firstNum === "1") {
            u.homeContactInfo.phoneMobile = u.homeContactInfo.phoneMobile.slice(1);
          }

          u.numberFormatted = this.formatPhoneNumber(u.homeContactInfo.phoneMobile);
        }

        if (u.authorities && u.authorities.length > 0) {
          u.defaultUserRole = this.mapRole(u.authorities[0].name);
        } else {
          u.defaultUserRole = "None";
        }
      });
    } catch (err) {
      console.log("issue with number..");
      console.dir(err);
    } finally {
      //this.formatUserAuths(users);
      this.companyUsers = users;
      this.getPendingInvitations();
    }
  }

  getPendingInvitations() {
    this.pendingInvites = [];
    this.$companies.getPendingInvitations().then((response) => {
      this.processPendingInvites(response.data);
      //this.processCancelledInvites(response.data);
    }, (error) => {
      console.log("getPendingInvitations error");
      console.dir(error);
    });
  }

  formatInviteDate(date) {
    return moment(date).format("MM/DD/YYYY");
  }

  resendInvite(data) {
    this.inviteUser(data);
  }

  cancelInvite(data) {
    this.setLoader();
    this.$companies.cancelPendingInvitation(data.invitationToken).then((response) => {
      this.removeCancelledInviteFromPendingList(data);
    }, (error) => {
      this.unSetLoader();
      console.error(error);
    });
  }

  removeCancelledInviteFromPendingList(data) {
    this.pendingInvites = this.pendingInvites.filter(function(obj) {
      return obj.email !== data.email;
    });
    this.$timeout(() => {
      this.unSetLoader();
    }, 300);
  }

  processCancelledInvites(canceledInvites) {
    this.cancelledInvites = [];
    try {
      canceledInvites.forEach((ci) => {
        if (ci.invitationStatus && ci.invitationStatus === "CANCELLED") {
          ci.invitationDateFormatted = this.formatInviteDate(ci.invitationDate);
          this.cancelledInvites.push(ci);
        }
      });
    } catch (err) {
      console.error(err);
    } finally {
      console.log("in the finally");
      console.dir(this.cancelledInvites);
    }
  }

  processPendingInvites(pendingInvites) {
    try {
      pendingInvites.forEach((pi) => {
        if (pi.invitationStatus && pi.invitationStatus === "PENDING") {
          console.log("we have a pending invite");
          console.dir(pi);
          pi.invitationDateFormatted = this.formatInviteDate(pi.invitationDate);
          this.pendingInvites.push(pi);
        }
      });
    } catch (err) {
      console.error(err);
    } finally {
      console.log("in the finally");
      console.dir(this.pendingInvites);
    }
  }

  formatUserAuths(users) {}

  isLetter(char) {
    let c = char.toString().toUpperCase();

    return c.toUpperCase().match("[A-ZÀ-ÚÄ-Ü]+") !== null;
  }

  codeEntered(num) {
    let isLetter = this.isLetter(this["smsCode_" + num]);

    if (isLetter === true) {
      this["smsCode_" + num] = null;
      return;
    }

    if (num <= 5 && this["smsCode_" + num]) {
      const el = document.getElementById("sms-code-" + (num + 1));
      el.focus();
      el.select();
    }

    let code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;

    if (code.length === 6) {
      this.validateSMSCode();
    }
  }

  smsCodeBackSpace(event, inputSequence) {
    if (event.keyCode === 8) {
      if (inputSequence !== 1) {
        let activeValue = $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + inputSequence).val();
        if (activeValue === "") {
          this.$timeout(() => {
            $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + (inputSequence - 1)).focus();
          });
        }
      }
    }
  }

  clearInputNumbers() {
    this.smsCode_1 = "";
    this.smsCode_2 = "";
    this.smsCode_3 = "";
    this.smsCode_4 = "";
    this.smsCode_5 = "";
    this.smsCode_6 = "";
    this.smsVerificationError = null;
  }

  resendAppLink() {
    this.$timeout(() => {
      this.smsLinkSending = true;
      this.smsLinkSennt = false;
    });
    this.sendAppLink().then(() => {
      this.$timeout(() => {
        this.smsLinkSending = false;
        this.smsLinkSennt = true;
      });
    });
  }

  validateSMSCode() {
    const code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;

    this.setLoader();

    this.$profiles
      .validateSMSCode(code)
      .then((response) => {
        this.$timeout(() => {
          this.smsVerified = true;
          this.submitAndSaveUser();
          this.unSetLoader();
        });
      })
      .catch((err) => {
        this.$timeout(() => {
          this.smsVerificationError = true;
          this.smsVerificationErrorText = "Code invalid or expired";
          this.unSetLoader();
          alert("There was an error validating your SMS code. Please try again or contact support.");
        }, 1000);
      });
  }

  exitPhoneVerification() {
    this.$timeout(() => {
      $("#verify-company-user").modal("toggle");
    });
  }

  submitAndSaveUser() {
    this.$timeout(() => {
      this.$auth.refreshCurrentUser().then((user) => {
        $("#verify-company-user").modal("toggle");
        this.organizeUsersWithVerifiedPhones(this.companyUsers, user);
        this.unSetLoader();
      });
    }, 1000);
  }

  organizeUsersWithVerifiedPhones(users, user) {
    console.log("organizeUsersWithVerifiedPhones");
    console.dir(users);
    console.dir(user);
    try {
      users.forEach((u) => {
        if (u.email === user.email) {
          if (u.homeContactInfo) {
            u.homeContactInfo.isMobilePhoneVerified = true;
            user.homeContactInfo.isMobilePhoneVerified = true;
            this.currentUser.homeContactInfo.isMobilePhoneVerified = true;
          }
        }
      });
    } catch (err) {
      console.log("in error");
      console.dir(err);
    } finally {
      console.log("in the finally");
      console.dir(users);
      console.dir(this.companyUsers);
      console.dir(user);
    }
  }

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");

    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return "+1 (" + match[1] + ") " + match[2] + "-" + match[3];
    }

    return null;
  }

  setLinkActive(link) {

    var _this = this;

    if (link === 1) {
      _this.$timeout(function () {
        $(".profile-edits-container .jobs-complete-sidebar li:nth-child(1)").removeClass().addClass("active");
        _this.getLogo(_this.currentUser.access_token);
      }, 500);
      _this.$timeout(function () {
        _this.unSetLoader();
      }, 700);
    }
    if (link === 2) {
      if (_this.currentUser.company.payByInvoice === true) {
        _this.unSetLoader();
        _this.pullLatestPaymentInfo();
        return;
      }
      _this.showPaymentInfo = false;
      _this.pullLatestPaymentInfo();
      _this.$timeout(function () {
        $(".profile-edits-container .jobs-complete-sidebar li:nth-child(2)").removeClass().addClass("active");
      }, 300);
    }
    if (link === 3) {
      _this.$timeout(function () {
        $(".profile-edits-container .jobs-complete-sidebar li:nth-child(3)").removeClass().addClass("active");
      }, 300);
      _this.$timeout(function () {
        _this.unSetLoader();
      }, 450);
    }
    if (link === 4) {
      _this.page = link;
      _this.getUserRoles();
    }
    if (link === 5) {
      if (_this.currentUser.company.payByInvoice === true) {
        return;
      }
      _this.$timeout(function () {
        $(".profile-edits-container .jobs-complete-sidebar li:nth-child(5)").removeClass().addClass("active");
      }, 300);
      _this.$timeout(function () {
        _this.unSetLoader();
      }, 450);
    }
    if (link === 6) {
      _this.$timeout(function () {
        $(".profile-edits-container .jobs-complete-sidebar li:nth-child(6)").removeClass().addClass("active");
      }, 300);
      _this.$timeout(function () {
        _this.unSetLoader();
      }, 450);
    }
    if (link === 7) {
      _this.$timeout(function () {
        $(".profile-edits-container .jobs-complete-sidebar li:nth-child(5)").removeClass().addClass("active");
      }, 300);
      _this.$timeout(function () {
        _this.unSetLoader();
      }, 450);
    }
  }

  loadPaymentData() {
    var _this = this;
    _this.remain_loading_count = 0;
  }

  should_we_disable_some_links(user) {
    var _this = this;

    if (user) {
      if (user.company) {
        if (user.company.payByInvoice === true) {
          _this.disable_left_links(true);
        } else {
          _this.disable_left_links(false);
        }
      }
    }

    _this.displayBankModal();
  }

  displayBankModal() {
    let verifyBank = parseInt(this.$location.$$search.verifyBank);
    if (verifyBank) {
      try {
        var selectedBank = this.currentUser.company.undeletedPaymentInfos.find((o) => o.id === verifyBank);
      } catch (err) {
        console.log("err");
        console.dir(err);
      } finally {
        this.$timeout(() => {
          this.$rootScope.$emit("SetBankAccount", {index: null, selectedBank: selectedBank});
        });
      }
    } else {
      console.log("dont display modal");
    }
  }

  disable_left_links(disable) {
    var _this = this;

    if (disable === true) {
      _this.$timeout(function () {
        $(".profile-edits-container .jobs-complete-sidebar li:nth-child(2)").addClass("fade-link");
      }, 100);
      _this.$timeout(function () {
        $(".profile-edits-container .jobs-complete-sidebar li:nth-child(5)").addClass("fade-link");
      }, 100);
    } else {
      _this.$timeout(function () {
        $(".profile-edits-container .jobs-complete-sidebar li:nth-child(2)").removeClass("fade-link");
      }, 100);
      _this.$timeout(function () {
        $(".profile-edits-container .jobs-complete-sidebar li:nth-child(5)").removeClass("fade-link");
      }, 100);
    }
  }

  loadSettings() {
    var _this = this;
    var sms = null;
    var email = null;

    _this.setLoader();
    _this.$companies.getSettings().then(
      function (response) {
        console.log("get settings...");
        console.dir(response);

        if (response.data.smsChatNotificationOn === null) {
          response.data.smsChatNotificationOn = true;
        }
        if (response.data.emailChatNotificationOn === null) {
          response.data.emailChatNotificationOn = true;
        }

        _this.settings = [
          {
            prop: 1,
            name: "SMS Notifications",
            value: response.data.smsChatNotificationOn,
            status: 1,
            statusText: response.data.smsChatNotificationOn ? "On" : "Off",
          },
          {
            prop: 2,
            name: "Email Notifications",
            value: response.data.emailChatNotificationOn,
            status: 1,
            statusText: response.data.emailChatNotificationOn ? "On" : "Off",
          },
        ];
        _this.privacy_settings = [
          {
            prop: 3,
            name: "Privacy Policy",
            value: response.data.acceptedPrivacyPolicy,
            status: 1,
            statusText: response.data.acceptedPrivacyPolicy ? "Agreed" : "Disagreed",
          },
        ];

        _this.currentUser.company.payByInvoice = response.data.company.payByInvoice;

        _this.setAccountTypes(response.data);
        _this.setInvoiceSettings(response.data);
        _this.should_we_disable_some_links(response.data);

        _this.$timeout(function () {
          _this.unSetLoader();
        }, 300);
      },

      function (error) {
        alert("Error getting settings");
      }
    );
  }

  setInvoiceSettings(data) {
    var _this = this;

    _this.invoice_settings = {};

    console.log("setInvoiceSettings");
    console.dir(data);

    let markup = null;
    if (data.company.invoiceMarkup) {
      markup = Math.round(data.company.invoiceMarkup * 100);
    }

    _this.invoice_settings.pays_by_invoice = data.company.payByInvoice;
    _this.invoice_settings.send_invoice = data.company.sendInvoice;
    _this.invoice_settings.weekly_billing = data.company.enableSubscription;
    _this.invoice_settings.markup = markup;

    _this.determineCheckBoxes(data.company);
  }

  determineCheckBoxes(company) {
    console.log("determine check boxes");
    console.dir(company);

    if (company.enableSubscription === true && company.sendInvoice === true) {
      this.invoice_settings.weekly_billing = false;
    } else {
      //this.invoice_settings.weekly_billing = true;
    }

    if (!company.enableSubscription && !company.payByInvoice) {
      this.invoice_settings.instant_charge = true;
    } else {
      this.invoice_settings.instant_charge = false;
    }

    if (company.payByInvoice === true) {
      this.invoice_settings.instant_charge = false;
    }

    if (company.enableSubscription === true) {
      this.invoice_settings.instant_charge = false;
    }
  }

  editBillingEmail() {
    if (!this.editingBusinessContact) {
      this.editingBusinessContact = true;
    } else {
      this.editingBusinessContact = false;
    }
  }

  update_invoice_settings(setting) {
    var _this = this;

    let value = null;
    let data = {};

    if (setting === 3) {
      if (_this.invoice_settings.send_invoice === true) {
        data.sendInvoice = false;
        data.enableSubscription = false;
        //data.enableSubscription = false;
        data.payByInvoice = false;
      } else {
        data.sendInvoice = true;
        data.enableSubscription = true;
        data.payByInvoice = false;
      }
    }

    if (setting === 1) {
      if (_this.invoice_settings.weekly_billing === true) {
        data.enableSubscription = false;
        data.sendInvoice = false;
      } else {
        data.enableSubscription = true;
        data.sendInvoice = false;
        data.payByInvoice = false;
      }
    }

    if (setting === 2) {
      if (_this.invoice_settings.pays_by_invoice === true) {
        data.payByInvoice = false;
      } else {
        data.payByInvoice = true;
        data.invoiceMarkup = (_this.invoice_settings.markup / 100).toFixed(2);
        data.enableSubscription = false;
        data.sendInvoice = false;
      }
    }

    if (setting === 4) {
      if (_this.invoice_settings.instant_charge === true) {
        alert("There must be one payment setting set to true. Please select from the other options.");
        return;
      } else {
        data.payByInvoice = false;
        data.enableSubscription = false;
        data.sendInvoice = false;
      }
    }

    _this.updateInvoiceSettings(data);
  }

  autoHirePreferenceChanging(preferenceNumber) {
    console.log("autoHirePreferenceChanging");
    console.dir(preferenceNumber);
  }

  updateInvoiceSettings(data) {
    var _this = this;

    _this.setLoader();

    console.log("updateInvoiceSettings");
    console.dir(data);

    _this.$companies.updateInvoiceSettings(data).then(
      function (response) {
        if (response.data.company.payByInvoice === true) {
          _this.invoice_settings.pays_by_invoice = true;
          _this.disable_left_links(true);
        } else {
          _this.invoice_settings.pays_by_invoice = false;
          _this.disable_left_links(false);
        }

        if (response.data.company.enableSubscription === true) {
          _this.invoice_settings.weekly_billing = true;
        } else {
          _this.invoice_settings.weekly_billing = false;
        }

        if (response.data.company.sendInvoice === true) {
          _this.invoice_settings.send_invoice = true;
        } else {
          _this.invoice_settings.send_invoice = false;
        }

        _this.save_invoice_success = true;
        _this.$timeout(function () {
          _this.save_invoice_success = false;
          _this.unSetLoader();
        }, 1000);

        _this.determineCheckBoxes(response.data.company);
        _this.getLatestCompanyPackage();
      },
      function (error) {
        _this.unSetLoader();
      }
    );
  }

  enterSave() {
    var _this = this;

    let data = {};
    data.invoiceMarkup = (_this.invoice_settings.markup / 100).toFixed(2);
    data.payByInvoice = true;
    _this.editing_percentage = false;

    _this.updateInvoiceSettings(data);
  }

  getLatestCompanyPackage() {
    var _this = this;
    if (_this.currentUser) {
      _this.$timeout(function () {
        _this.$auth.getCompanyPlan().then(
          function (response) {
            _this.currentUser.company.defaultPlan = response.data.company.defaultPlan;
          },
          function (error) {}
        );
      }, 1000);
    }
  }

  editPercentage() {
    var _this = this;
    console.log("editPercentage");
    if (_this.editing_percentage) {
      _this.editing_percentage = false;
    } else {
      _this.editing_percentage = true;
      _this.$timeout(function () {
        $("table.account-profile-settings-table.invoice-edits tr td input.save-invoice-input").focus();
      });
    }
  }

  cancelInvoiceUpdate() {
    this.editing_percentage = false;
  }

  updateInvoiceMargins() {
    var _this = this;

    let data = {};
    data.invoiceMarkup = (_this.invoice_settings.markup / 100).toFixed(2);
    data.payByInvoice = true;
    _this.editing_percentage = false;
    _this.updateInvoiceSettings(data);
  }

  toggleSettings(row, x) {
    var _this = this;

    console.log("toggleSettings");
    console.dir(row);
    console.dir(x);

    var data = {};

    if (row.prop === 3) {
      console.log("in porop 3");
      //data.acceptedPrivacyPolicy;
      if (row.statusText === "Disagreed") {
        data.acceptedPrivacyPolicy = true;
        row.statusText = "Agreed";
      } else {
        data.acceptedPrivacyPolicy = false;
        row.statusText = "Disagreed";
      }
    } else if (row.prop === 2) {
      if (row.statusText === "On") {
        data.emailChatNotificationOn = false;
        row.statusText = "Off";
      } else {
        data.emailChatNotificationOn = true;
        row.statusText = "On";
      }
    } else {
      if (row.statusText === "On") {
        data.smsChatNotificationOn = false;
        row.statusText = "Off";
      } else {
        data.smsChatNotificationOn = true;
        row.statusText = "On";
      }
    }

    row.status = 1;

    _this.$timeout(function () {
      if (row.prop === 3) {
        _this.save_priv_success = true;
        _this.timerNotifications(row);
      } else {
        _this.save_noti_success = true;
        _this.timerNotifications(row);
      }
    }, 300);

    _this.$companies.updateNotifications(data).then(
      function (response) {
        console.log("resonse form noti update");
        console.dir(response);
      },
      function (error) {
        alert("error updating settings");
      }
    );
  }

  timerNotifications(row) {
    var _this = this;

    _this.$timeout(function () {
      _this.save_noti_success = false;
      _this.save_priv_success = false;
    }, 6000);
  }

  getPlans(m, o) {
    var _this = this;

    console.log("get plans?");

    this.$auth.getPlans(m, o).then(
      function (response) {
        var t = [];

        try {
          if (response.data.status !== "error") {
            response.data.forEach(function (plan, index) {
              if (_this.currentUser.company.defaultPlan.id === plan.id) {
                plan.isChecked = true;
                plan.isActive = "active-plan";
              } else {
                plan.isChecked = false;
              }

              t.push(plan);
            });
          } else {
          }
        } finally {
          _this.plans = t;
          console.log("what are the plans");
          console.dir(_this.plans);
        }
      },
      function (response) {
        if (data.status === 401) {
          _this.$state.go("signin");
        } else {
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      }
    );
  }

  handleAddingUserError(data) {
    var _this = this;
    if (data.data.message) {
      _this.errorMessageRegi = data.data.message;
    } else {
      _this.$timeout(function () {
        jQuery("#modal-add-user-confirm-modal .modal-header button.close").trigger("click");
      }, 100);
      _this.$timeout(function () {
        jQuery("#show-application-alert").trigger("click");
      }, 300);
    }
  }

  setActivePageOnLeft() {
    var _this = this;

    _this.setLoader();

    if (!this.$stateParams) {
      console.log("state params are empty");
    }

    if (this.$location.$$path.indexOf("company-users") > -1) {
      _this.page = 4;
      _this.$timeout(function () {
        _this.getUserRoles();
        _this.loadUsers();
      }, 300);
      //this.setLinkActive(4);
      //this.loadUsers();
    }

    if (this.$location.$$path.indexOf("payment-information") > -1) {
      this.page = 2;
      this.setLinkActive(2);
      this.loadPaymentData();
    }

    if (this.$location.$$path.indexOf("subscription-plans") > -1) {
      this.page = 5;
      this.setLinkActive(5);
      this.getPlans();
    }

    if (this.$location.$$path.indexOf("settings") > -1) {
      this.page = 3;
      this.setLinkActive(3);
      this.loadSettings();
    }

    if (this.$location.$$path.indexOf("payment-history") > -1) {
      this.page = 6;
      this.setLinkActive(6);
      //this.loadSettings();
    }

    if (this.$location.$$path.indexOf("notification-center") > -1) {
      this.page = 7;
      this.setLinkActive(7);
      this.getUserNotficationPreferences();
    }

    if (!this.$stateParams.companyId) {
      this.page = 1;
      this.remain_loading_count = 0;
      this.setLinkActive(1, true);
    }

    _this.should_we_disable_some_links(_this.currentUser);
  }

  checkForRDS() {
    var _this = this;

    let user = _this.currentUser;
    let on_payment_page = _this.$location.$$path.indexOf("payment-information") > -1;

    if (user.company.undeletedPaymentInfos) {
      user.company.paymentInfos = user.company.undeletedPaymentInfos;
    } else {
      user.company.paymentInfos = [];
    }

    if (user.company.partner && user.company.paymentInfos.length === 0 && on_payment_page) {
      //console.log('we have a partner with no payment information');
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetWarningForRDSCustomer", {});
      }, 1000);
    }
  }

  clearPayInfo() {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("ClearPayInfo", {});
    });
  }

  initAccounts() {
    var _this = this;

    _this.setLoader();

    let data = {};

    let clientSecret;

    data.confirm = true;
    data.usage = "off_session";

    let contactEmail;

    if (this.currentUser.company.billingContactInfo.email) {
      contactEmail = this.currentUser.company.billingContactInfo.email;
    } else {
      contactEmail = this.currentUser.username;
    }

    this.$companies.getIntentKey(data).then(
      (response) => {
        console.log("what is the response");
        console.dir(response.data);
        clientSecret = response.data.clientSecret;

        this.stripe
          .collectBankAccountForSetup({
            clientSecret: response.data.clientSecret,
            params: {
              payment_method_type: "us_bank_account",
              payment_method_data: {
                billing_details: {name: "Jobble Admin", email: contactEmail},
              },
            },
          })
          .then(function (result) {
            console.log("collectBankAccountForSetup");
            console.dir(result);

            if (result.error) {
              // Inform the customer that there was an error.
              console.log(result.error.message);
              alert(result.error.message);
              // Handle next step based on length of accounts
            } else if (!result.setupIntent) {
              console.log("No setupIntent created....");
              alert("No setupIntent created....");
            } else if (result.setupIntent.next_action && result.setupIntent.next_action.type === "verify_with_microdeposits") {
              alert("we need micro deposits");
            } else {
              _this.handleSetupIntent(result.setupIntent, clientSecret);
            }
          });
      },
      (error) => {
        alert("Error getting intent: " + error);
      }
    );
  }

  handleSetupIntent(setupIntent, clientSecret) {
    if (!setupIntent.payment_method) {
      console.error("User exited modal.");
      this.unSetLoader();
      return;
    }

    console.log("handle setup intent");
    console.dir(setupIntent);
    if (setupIntent.status === "requires_confirmation") {
      console.log("display mandate...");
      console.dir(setupIntent);
      this.mandateData = {
        setupIntent: setupIntent,
        clientSecret: clientSecret,
      };
      this.triggerMandate(setupIntent);
      //this.updateSetupIntent(setupIntent);
      //this.confirmBankAccountSetup(setupIntent, clientSecret);
    } else {
      this.confirmBankAccountSetup(setupIntent, clientSecret);
    }
  }

  confirmMandate() {
    if (this.disableMandateButton === true) {
      return;
    }
    this.disableMandateButton = true;
    this.setLoader();
    let setupIntent = this.mandateData.setupIntent;
    let clientSecret = this.mandateData.clientSecret;
    this.confirmBankAccountSetup(setupIntent, clientSecret);
    delete this.mandateData.setupIntent;
    delete this.mandateData.clientSecret;
    this.$timeout(() => {
      $("#stripe-mandate-display").modal("toggle");
    }, 500);
  }

  triggerMandate(setupIntent) {
    this.disableMandateButton = false;
    this.$timeout(() => {
      this.unSetLoader();
      $("#stripe-mandate-display").modal();
    }, 1000);
  }

  confirmBankAccountSetup(intent, clientSecret) {
    this.stripe.confirmUsBankAccountSetup(clientSecret).then(({setupIntent, error}) => {
      console.log("confirmBankAccountSetup response...");
      console.dir(setupIntent);
      if (error) {
        console.error(error.message);
        this.unSetLoader();
        // The payment failed for some reason.
      } else if (setupIntent.status === "requires_payment_method") {
        this.unSetLoader();
        // Confirmation failed. Attempt again with a different payment method.
      } else if (setupIntent.status === "succeeded") {
        // Confirmation succeeded! The account is now saved.
        // Display a message to customer.
        this.updateSetupIntent(setupIntent, false);
      } else if (setupIntent.status === "requires_action" && setupIntent.next_action.type === "verify_with_microdeposits") {
        // The account needs to be verified via microdeposits.
        // Display a message to consumer with next steps (consumer waits for
        // microdeposits, then enters a statement descriptor code on a page sent to them via email).
        this.unSetLoader();
        this.updateSetupIntent(setupIntent, true);
        //this.updateSetupIntent(setupIntent);
        //this.actionRequired(setupIntent);
      }
    });
  }

  actionRequired(setupIntent) {
    console.log("actionRequired");
    alert("We need to verify this account with micro deposits");
  }

  updateSetupIntent(setupIntent, requiresMicroDepositConfirmation) {
    console.log("updateSetupIntent");
    console.dir(setupIntent);

    let payload = {};

    payload.setupId = setupIntent.id;
    payload.paymentMethodId = setupIntent.payment_method;

    if (requiresMicroDepositConfirmation) {
      payload.requiresMicroDepositConfirmation = true;
    }

    console.log("-------------------payload----------------------");
    console.dir(payload);

    this.$companies.updateIntentKey(payload).then(
      (response) => {
        console.log("updateIntentKey");
        console.dir(response);
        this.handleUpdateIntent(response.data);
      },
      (error) => {
        console.log("error");
        console.dir(error);
        this.unSetLoader();
        alert("Error from handleSetupIntent error status : " + error.status);
      }
    );
  }

  handleUpdateIntent(bankAccount) {
    console.log("handleUpdateIntent");
    console.dir(bankAccount);

    if (!bankAccount.paymentInfoId) {
      console.error("User exited modal.");
      this.unSetLoader();
      return;
    }

    bankAccount.id = bankAccount.paymentInfoId;
    bankAccount.validated = bankAccount.paymentInfoValidated;

    this.banksArray.push(bankAccount);

    this.unSetLoader();
  }

  initConnections() {
    var _this = this;

    const stripe = window.Stripe(_this.$env.EnvironmentConfig.stripeKey);

    _this.setLoader();

    this.$companies.getFcaKey().then(
      (response) => {
        console.log("what is the response");
        console.dir(response.data);
        stripe
          .collectFinancialConnectionsAccounts({
            clientSecret: response.data.clientSecret,
          })
          .then(function (result) {
            if (result.error) {
              // Inform the customer that there was an error.
              console.log(result.error.message);

              // Handle next step based on length of accounts array
            } else if (result.financialConnectionsSession.accounts.length === 0) {
              console.log("No accounts were linked");
            } else {
              console.log("response from collectFinancialConnectionsAccounts");
              console.log(result);
            }
          });
      },
      (error) => {
        alert("Error getting user roles - contact admin : " + error);
      }
    );
  }

  setAccountTypes(user) {
    var _this = this;

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetPostingTypes", user);
    });
  }

  updateIndustryTypeOfCompany() {
    var _this = this;

    let latest_id = _this.account_type_settings.value.id;
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  submitOnEnter(e) {
    if (e.keyCode === 13) {
      this.updateUsersBillingEmail();
    }
  }

  updateUsersBillingEmail() {
    if (this.validation.email && this.validation.email.valid === false) {
      alert("Error validating billing contact: " + this.validation.email.message);
      return;
    }

    if (!this.validation.email) {
      this.editingBusinessContact = false;
      return;
    }

    let data = {};
    data.company = {};
    data.company.billingContactInfo = {};
    data.company.billingContactInfo.email = this.currentUser.company.billingContactInfo.email;
    this.editingBusinessContact = false;
    this.setLoader();
    this.$timeout(() => {
      this.$companies.updateCompanyBillingEmail(data).then(
        (response) => {
          this.unSetLoader();
          this.$auth.reloadCurrentUser();
        },
        (error) => {
          this.unSetLoader();
          console.log("transfer error, error:", error);
          // alert("Error : " + error);
          alert("There was an error updating the billing contact. Please try again.");
        }
      );
    }, 1500);
  }

  cancelUsersBillingEmail() {
    this.editingBusinessContact = false;
  }

  getUserRoles() {
    this.$companies.getAuth().then(
      (response) => {
        this.$companies.getUserRoles().then(
          (response) => {
            this.userRollsAPI = response.data;
            this.formatUserRoles(response.data);
          },
          (error) => {
            alert("Error getting user roles - contact admin : " + error);
          }
        );
      },
      (error) => {
        alert("Error getting user roles - contact admin : " + error);
      }
    );
  }

  formatUserRoles(roles) {

    let userRoles = [];

    this.defaultUserRole = "HR Manager";

    try {
      roles.forEach(function (role) {
        if (role.name === "GROUP_COMPANY_ADMIN") {
          userRoles.push("HR Manager");
        } else if (role.name === "GROUP_FINANCE") {
          userRoles.push("Finance");
        } else if (role.name === "GROUP_ONSITE_MANAGER") {
          userRoles.push("On Site Manager");
        }
      });
    } catch (err) {
      console.log("error with roles");
      console.dir(err);
    } finally {
      //userRoles.unshift("None");
      this.userRoles = userRoles;
    }
  }

  removeUpdateButton(index) {
    this.$timeout(() => {
      $(".account-gradient-button.show-hide.item-number-" + index).removeClass("show-hide-show");
    });
  }

  updateRoleButton(user, index) {
    console.log("updateRoleButton");
    console.dir(user);

    if (user.homeContactInfo.isMobilePhoneVerified !== true && user.defaultUserRole === "On Site Manager") {
      user.defaultUserRole = "None";
      alert("This user does not have a verified phone number and cannot be an On Site Manager.");
      return;
    }

    if (user.defaultUserRole === "None") {
      this.removeUpdateButton(index);
      return;
    }

    this.$timeout(() => {
      $(".account-gradient-button.show-hide.item-number-" + index).addClass("show-hide-show");
    });
  }

  updateRoleModal() {}

  updateRole(user, i) {
    this.setLoader();
    let data = {};
    let groupId = this.mapRoles(user.defaultUserRole);

    data.userId = user.id;
    data.groupId = groupId;

    this.$companies.updateUserRoles(data).then(
      (response) => {
        this.unSetLoader();
        this.removeUpdateButton(i);
        this.displaySuccessMessage(user);
      },
      (error) => {
        alert("Error getting user roles - contact admin : " + error);
        this.removeUpdateButton(i);
        this.$timeout(() => {
          this.unSetLoader();
        }, 1000);
      }
    );
  }

  displaySuccessMessage(user) {
    this.$timeout(() => {
      $("#modal-successful-role-add").modal();
    });
  }

  mapRoles(role) {
    let id;

    if (role === "Finance") {
      this.userRollsAPI.forEach(function (r) {
        //if (r.)
        if (r.name === "GROUP_FINANCE") {
          id = r.id;
        }
      });
    } else if (role === "HR Manager") {
      this.userRollsAPI.forEach(function (r) {
        if (r.name === "GROUP_COMPANY_ADMIN") {
          id = r.id;
        }
      });
    } else if (role === "On Site Manager") {
      this.userRollsAPI.forEach(function (r) {
        if (r.name === "GROUP_ONSITE_MANAGER") {
          id = r.id;
        }
      });
    }

    return id;
  }

  mapRole(role) {
    let answer;

    if (role === "GROUP_FINANCE") {
      answer = "Finance";
    } else if (role === "GROUP_COMPANY_ADMIN") {
      answer = "HR Manager";
    } else if (role === "GROUP_ONSITE_MANAGER") {
      answer = "On Site Manager";
    }

    return answer;
  }

  inviteUser(d) {

    var _this = this;
    var email = _this.newUserObj.email;

    if (this.invitingUser === true) {
      return;
    }

    this.invitingUser = true;

    if (!email && !d) {
      alert("Please provide an email to invite.");
      return;
    }

    this.setLoader();

    let data = {};
    if (d) {
      data.username = d.email;
      data.group = {};
      data.allowDifferentDomain = true;
      data.group.id = d.invitationGroupId;
    } else {
      if (email) {
        data.username = email;
        data.group = {};
        data.allowDifferentDomain = true;
        if (this.defaultUserRole) {
          if (this.defaultUserRole === "Finance") {
            data.group.id = this.mapRoles("Finance");
          } else if (this.defaultUserRole === "HR Manager") {
            data.group.id = this.mapRoles("HR Manager");
          } else if (this.defaultUserRole === "On Site Manager") {
            data.group.id = this.mapRoles("On Site Manager");
          }
        }
      } else {
        console.err("Missing an email for invite");
      }
    }

    console.log("invitation payload");
    console.dir(data);

    var req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "register/invite-user?format=json&conf=web?action=inviteUser",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: data,
    };

    this.$http(req)
      .then(function (data) {
        _this.unSetLoader();
        _this.$timeout(function () {
          _this.invitingUser = false;
        }, 1000);
        if (data.data.status === "success") {
          _this.getPendingInvitations();
          _this.$timeout(function () {
            jQuery("#modal-add-user-confirm-modal .modal-header button.close").trigger("click");
          }, 100);
          _this.$timeout(function () {
            jQuery("#modal-invite-user-confirm-modal").modal();
          }, 500);
        } else {
          _this.handleAddingUserError(data);
        }
      })
      .catch((err) => {
        _this.$timeout(function () {
          _this.invitingUser = false;
        }, 1000);
        _this.unSetLoader();
        _this.handleAddingUserError(err);
      });
    }

  setBillingEmail(email, fromHtml) {
    console.log("setBillingEmail");
    console.dir(email);
    console.dir(fromHtml);
    if (fromHtml) {
      this.companyDisplayData.billing_contact = email;
    }
  }

  getLogo(token) {
    var _this = this;

    _this.setLoader();

    if (token) {
      _this.$auth.grab_company_logo(token).then(
        function (response) {
          console.log("response from logo");
          console.dir(response);
          let logo = response.data.company.companyLogoUri;
          if (logo) {
            _this.currentUser.companyProfilePictureUrl = logo;
            _this.determineImageDimensions(logo);
          } else {
            _this.currentUser.companyProfilePictureUrl = "/app/vendor/images/user-more.png";
          }

          _this.$timeout(function () {
            _this.unSetLoader();
          }, 300);
        },
        function (error) {
          alert("There was an error getting company logo");
          _this.unSetLoader();
        }
      );
    }
  }

  pullLatestPaymentInfo(bankToRemove) {
    this.$profiles.getPaymentInfo().then(
      (response) => {
        this.currentUser.company.undeletedPaymentInfos = response.data.company.undeletedPaymentInfos;
        this.paymentInfos = response.data.company.undeletedPaymentInfos;
        this.organizePaymentInfo(false, bankToRemove);
        this.showPaymentInfo = true;
        this.$timeout(() => {
          this.unSetLoader();
        }, 1500);
      },
      (error) => {
        this.showPaymentInfo = true;
        this.unSetLoader();
        alert("Error loading users payment information : " + error.status);
      }
    );
  }

  getUserNotficationPreferences() {
    this.setLoader();
    this.$companies.getNotificationPreferences().then(
      (response) => {
        this.unSetLoader();
        console.log("response");
        console.dir(response);
        this.setNotificationSettings(response);
      },
      (error) => {
        console.log("what is error");
        console.dir(error);
        this.unSetLoader();
        alert("Error loading users payment information : " + error.status);
      }
    );
  }

  createNotificationPreferences(data) {
    this.setLoader();
    console.log("createNotificationPreferences");
    console.dir(data);

    this.$companies.createNotificationPreferences(data).then(
      (response) => {
        this.unSetLoader();
        console.log("response");
        console.dir(response);
      },
      (error) => {
        console.log("what is error");
        console.dir(error);
        this.unSetLoader();
        alert("Error loading users payment information : " + error.status);
      }
    );

  }

  createOrUpdateNotificationPreferences(data, item, displayMessageType) {
    this.setLoader();
    this.notificationMessage = null;
    this.specificMessage = null;

    this.$companies.createOrUpdateNotificationPreferences(data).then(
      (response) => {
        this.unSetLoader();
        this.displayModalNotificationCenter("success", data, item, displayMessageType);
        //console.log("response");
        //console.dir(response);
      },
      (error) => {
        //console.log("what is error");
        //console.dir(error);
        this.displayModalNotificationCenter("error", data, item, displayMessageType);
        this.unSetLoader();
        alert("Error loading users payment information : " + error.status);
      }
    );
  }

  displayModalNotificationCenter(type, data, item, displayMessageType) {

    let message;
    let specificMessage;
    let bodyText;

    if (type === "success") {
      specificMessage = this.determineSpecificMessage("success", item);
      if (displayMessageType) {
        message = "Your notification settings were successfully updated";
        bodyText = "The following notifications have been activated for your account:";
      } else {
        message = "Your notification settings were successfully updated";
        bodyText = "The following notifications have been deactivated for your account:";
      }
    } else {
      message = "There was an issue with saving your notification settings";
      specificMessage = this.determineSpecificMessage("error", item);
    }

    this.$timeout(() => {
      $("#notification-center-modal").modal();
    }, 200);

    this.specificMessage = specificMessage;
    this.notificationMessage = message;
    this.notificationBodyText = bodyText;

  }

  determineSpecificMessage(type, item, determineSpecificMessage) {
    console.log("determineSpecificMessage");
    console.dir(item);
    let n = [];

    if (type === "success") {
        item.sub_fields.forEach(function (x) {
          n.push(x.description);
        });
    } else {
      n.push("There was an error");
    }

    return n;
  }

  closeNotificationModal() {
    this.$timeout(() => {
      $("#notification-center-modal").modal("toggle");
    });
  }

  setNotificationSettings(settings) {
    console.log("setNotificationSettings");
    console.dir(settings);
    let s = settings.data;
    try {
      this.notificationCenter.forEach(function (item) {
        console.log("each item");
        console.dir(item);
        if (item.title === "Roster") {
          if (s.roster === true) {
            item.activated = true;
          }
        }
        if (item.title === "Job Status") {
          if (s.jobStatus === true) {
            item.activated = true;
          }
        }
        if (item.title === "Live Job Updates") {
          if (s.liveJob === true) {
            item.activated = true;
          }
        }
        if (item.title === "Billing") {
          if (s.billing === true) {
            item.activated = true;
          }
        }
      });
    } catch (err) {
      console.log("looping error");
      console.dir(err);
    } finally {
      console.log("in the finally");
      console.dir(this.notificationCenter);
    }
  }

  setAllAsClickedAndUpdate(item) {

    if (item.activated === true) {
        item.activated = false;
    } else {
        item.activated = true;
    }

    let displayMessageType = item.activated;

    let data = {};

    this.notificationCenter.forEach(function (item) {
      if (item.activated) {
        if (item.title === "Roster") {
          data.roster = true;
        }
        if (item.title === "Job Status") {
          data.jobStatus = true;
        }
        if (item.title === "Live Job Updates") {
          data.liveJob = true;
        }
        if (item.title === "Billing") {
          data.billing = true;
        }
      } else {
        if (item.title === "Roster") {
          data.roster = false;
        }
        if (item.title === "Job Status") {
          data.jobStatus = false;
        }
        if (item.title === "Live Job Updates") {
          data.liveJob = false;
        }
        if (item.title === "Billing") {
          data.billing = false;
        }
      }
    });

    this.createOrUpdateNotificationPreferences(data, item, displayMessageType);

  }

  companyProfileText() {

    let text;

    if (!this.currentUser) {
      return;
    }

    if (this.currentUser.firstName) {
      text = this.currentUser.firstName;
    }

    if (this.currentUser.lastName) {
      text += " " + this.currentUser.lastName + ",";
    }

    text = text + " " + this.currentUser.username;

    return text;
  }

  updatePassword() {
    var _this = this;
    this.setLoader();
    let payload = {};
    let userId = this.currentUser.id;
    payload.currentPassword = this.passwordData.currentPassword;
    payload.newPassword = this.passwordData.newPassword;
    payload.confirmNewPassword = this.passwordData.confirmNewPassword;
    this.updatePasswordFormInvalid = true;
    this.$profiles.updatePassword(payload, userId).then((response) => {
      this.updatePasswordModal(false);
      this.handleUpdatePasswordResponse(response);
      this.unSetLoader();
    }, (error) => {
      _this.unSetLoader();
      _this.passNotMatching = false;
      alert(error.data.message);
    });
  }

  handleUpdatePasswordResponse(response) {
    this.$timeout(() => {
      $("#update-password-confirm").modal();
    }, 500);
  }

  validateNewPassword() {
    let result = false;
    if (this.passwordData && this.passwordData.newPassword) {
      if (/\d/.test(this.passwordData.newPassword)) {
        result = true;
      } else {
        result = false;
      }
    }
    return result;
  }

  updatePasswordModal(open) {
    this.passwordData = {};
    if (open === true) {
      this.passNotMatching = false;
      this.setFocusOnFirstInput();
      this.updatePasswordFormInvalid = true;
      this.$timeout(() => {
        $("#update-password").modal();
      }, 100);
    } else {
      this.$timeout(() => {
        $("#update-password").modal("toggle");
      });
    }
  }

  setFocusOnFirstInput() {
    this.$timeout(() => {
      $(".popup input[type='password'].current-password").focus();
    }, 600);
  }

  validateNewPasswordConfirmation() {
    if (this.passwordData && this.passwordData.newPassword && this.passwordData.confirmNewPassword) {
      if ((this.passwordData.newPassword.length > 7) && (/\d/.test(this.passwordData.newPassword))) {
        if (this.passwordData.newPassword === this.passwordData.confirmNewPassword) {
          this.passNotMatching = false;
          this.updatePasswordFormInvalid = false;
        } else {
          if (this.passwordData.confirmNewPassword.length > 6) {
            this.passNotMatching = true;
          }
        }
      }
    }
  }

  logUserOut() {
    this.$timeout(() => {
      this.$state.go("signin", {onRefresh: true});
    }, 300);
  }

}

AccountprofileController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "companies",
  "signup.validator",
  "security",
  "$timeout",
  "$rootScope",
  "env",
  "ngProgressFactory",
  "$scope",
  "$location",
  "profile",
];

export default AccountprofileController;



// WEBPACK FOOTER //
// ./client/app/components/accountprofile/accountprofile.controller.js